export default __webpack_public_path__ + "images/69b66bc95c8cd771b802369aa119ce22-hvm.png";